"use client";

import {
  AddLetterHead,
  ListLetterHead,
  EditLetterHead,
  DeleteLetterHead,
} from "../../services/letter";
import { GenericSelectorDrawer } from "./generic-selector-drawer";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

export function LetterheadSelector({
  selectedLetterhead,
  onSelect,
  onClose,
  currentUserId,
}) {
  const fetchLetterheads = async () => {
    const res = await ListLetterHead();
    return res.data.map((item) => ({
      id: item.idsarbargstr,
      idsarbarg: item.idsarbarg || 0,
      idUser: item.idUser || currentUserId || 0,
      name: item.name,
      pathimg: item.pathimg || "",
      file: item.file || "",
    }));
  };

  const addLetterhead = async (itemData) => {
    const formData = new FormData();
    formData.append("name", itemData.name);
    formData.append("pathimg", "0");
    formData.append("file", itemData.file);
    formData.append("idUser", currentUserId || 0);

    try {
      await AddLetterHead(formData);
      toast.success("سربرگ با موفقیت اضافه شد");
    } catch (err) {
      console.error(err);
      toast.error("خطا در افزودن سربرگ");
      throw err;
    }
  };

  const editLetterhead = async (id, itemData) => {
    const formData = new FormData();
    
    // Required fields according to API schema
    formData.append("idsarbarg", itemData.idsarbarg || 0); // integer
    formData.append("idsarbargstr", id); // string (the id passed is the string ID)
    formData.append("idUser", itemData.idUser || currentUserId || 0); // integer
    formData.append("name", itemData.name); // string
    formData.append("pathimg", itemData.pathimg || "0"); // string
    
    // File only if selected (optional)
    if (itemData.file) {
      formData.append("file", itemData.file); // binary
    }

    try {
      await EditLetterHead(id, formData);
      toast.success("سربرگ با موفقیت ویرایش شد");
    } catch (err) {
      console.error(err);
      toast.error("خطا در ویرایش سربرگ");
      throw err;
    }
  };

  const deleteLetterhead = async (id) => {
    const result = await Swal.fire({
      title: "حذف سربرگ",
      text: "آیا از حذف این سربرگ اطمینان دارید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف",
      customClass: {
        container: "swal2-z-index",
      },
      zIndex: 1400,
    });

    if (result.isConfirmed) {
      try {
        await DeleteLetterHead(id);
        toast.success("سربرگ با موفقیت حذف شد");
      } catch (err) {
        console.error(err);
        toast.error("خطا در حذف سربرگ");
        throw err;
      }
    }
  };

  const fields = [
    {
      name: "name",
      label: "نام سربرگ",
      placeholder: "مثلاً: سربرگ شخصی",
      required: true,
      autoFocus: true,
    },
  ];

  return (
    <GenericSelectorDrawer
      title="سربرگ"
      isOpen={onClose ? true : false}
      onClose={onClose}
      selectedItem={selectedLetterhead}
      onSelect={onSelect}
      fetchItems={fetchLetterheads}
      addItem={addLetterhead}
      editItem={editLetterhead}
      deleteItem={deleteLetterhead}
      formFields={fields}
      fileUploadId="upload-letterhead-image"
      fileUploadLabel="انتخاب تصویر سربرگ"
      emptyMessage="هیچ سربرگی یافت نشد."
      selectViewTitle="انتخاب سربرگ"
      addViewTitle="افزودن سربرگ جدید"
      editViewTitle="ویرایش سربرگ"
      confirmLabel="تأیید انتخاب"
      addLabel="ذخیره"
      addButtonLabel="افزودن سربرگ جدید"
    />
  );
}
